<template>
  <v-dialog
    v-model="active"
    max-width="80%"
    transition="dialog-bottom-transition"
  >
    <Tooltip content="Close" active top color="red">
      <v-btn
        @click="active = false"
        elevation="0"
        fab
        absolute
        width="25"
        height="25"
        v-if="active"
      >
        <v-icon size="25">mdi-close-circle</v-icon>
      </v-btn>
    </Tooltip>
    <v-sheet height="100%" class="py-5 px-3 mh15 hm90 scrollable">
      <!-- <h3 class="text-decoration-underline text-left">Response:</h3> -->
      <!-- <pre v-if="isJSON" v-html="highlightJSON(result)"></pre> -->
      <JsonPreview v-if="isJSON" :obj="result" />
      <p
        v-if="isHTML"
        v-html="result"
        disabled
        class="fill-height inactiveLink"
      ></p>
      <div v-if="isLog">
        <h4 class="title text-center">
          <v-icon small>mdi-console</v-icon> Console & Network Logs
        </h4>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in result" :key="i">
            <v-expansion-panel-header>
              <v-row>
                <v-col cols="auto">
                  <v-icon
                    small
                    color="info"
                    v-text="'mdi-' + parseLog(item).icon"
                  >
                  </v-icon>
                </v-col>
                <v-col class="text-left b" cols="10">
                  {{ truncate(parseLog(item).text) }}
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-2">
              {{ parseLog(item).text }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <!-- <v-list dense v-if="isLog">
        <v-subheader>Logs</v-subheader>
        <v-list-item-group color="info">
          <v-list-item v-for="(item, i) in result" :key="i">
            <v-list-item-icon>
              <v-icon small v-text="('mdi-'+parseLog(item).icon)"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="parseLog(item).text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list> -->
    </v-sheet>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import Tooltip from "@/components/Tooltip.vue";
import JsonPreview from "@/components/JsonPreview.vue";
import { logsIcon, truncate } from "@/utils";

export default Vue.extend({
  name: "ResponseDialog",
  data() {
    return {};
  },
  methods: {
    parseLog(item: string): { icon: string; text: string } {
      const parsed: string[] = item.split(" -> ");
      const itemObj = { icon: logsIcon[parsed[0]], text: parsed[1] };
      return itemObj;
    },
    truncate,
  },
  computed: {
    result(): any {
      return this.$store.getters.getResponse;
    },
    active: {
      get(): boolean {
        const res = this.result;
        return typeof res === "object"
          ? Object.keys(res).length > 0
          : res.length > 0;
      },
      set(val: boolean) {
        if (!val) {
          this.$store.commit("setResponse");
        }
      },
    },
    options(): any {
      return this.$store.getters.getResponseOptions;
    },
    isLog(): boolean {
      return this.options.type === "log";
    },
    isHTML(): boolean {
      return this.options.type === "html" && typeof this.result == "string";
    },
    isJSON(): boolean {
      return this.options.type === "html" && typeof this.result == "object";
    },
  },
  components: { Tooltip, JsonPreview },
});
</script>
<style>
.inactiveLink {
  pointer-events: none;
  cursor: default;
  position: relative;
}
</style>
